import { useMutation } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_EXPORT_PROCUREMENT_SUPPLIERS = "EXPORT_PROCUREMENT_SUPPLIERS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const exportProcurementSuppliers = async (): Promise<void> => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const response =
    await procurementApi.procurementControllerExportProcurementSuppliers(timezone, {
      responseType: "blob",
    });

  const url = window.URL.createObjectURL(response.data as unknown as Blob);

  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", "suppliers.csv");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const useExportProcurementSuppliers = (
  user: UserProfileDto | null,
): {
  exportProcurementSuppliers: () => void;
  exportProcurementSuppliersEnabled: boolean;
  isPendingExportProcurementSuppliers: boolean;
  isSucessExportProcurementSuppliers: boolean;
  isErrorExportProcurementSuppliers: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { mutate, isPending, isSuccess, isError } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_EXPORT_PROCUREMENT_SUPPLIERS],
    mutationFn: enabled ? exportProcurementSuppliers : undefined,
  });

  return {
    exportProcurementSuppliers: mutate,
    exportProcurementSuppliersEnabled: enabled,
    isPendingExportProcurementSuppliers: isPending,
    isSucessExportProcurementSuppliers: isSuccess,
    isErrorExportProcurementSuppliers: isError,
  };
};
